import { render, staticRenderFns } from "./product-eans.vue?vue&type=template&id=25fa5200&scoped=true"
import script from "./product-eans.vue?vue&type=script&lang=js"
export * from "./product-eans.vue?vue&type=script&lang=js"
import style0 from "./product-eans.vue?vue&type=style&index=0&id=25fa5200&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fa5200",
  null
  
)

export default component.exports